export interface City {
  name: string;
  slug: string;
  state: string;
  stateSlug: string;
  stateCode: string;
  id: number;
}

export interface Region {
  name: string;
  cities: City[];
}

export const regions: Region[] = [
  {
    name: "Região Sudeste",
    cities: [
      {
        name: "São Paulo",
        slug: "sao-paulo",
        state: "São Paulo",
        stateSlug: "sao-paulo",
        stateCode: "SP",
        id: 5341,
      },
      {
        name: "Rio de Janeiro",
        slug: "rio-de-janeiro",
        state: "Rio de Janeiro",
        stateSlug: "rio-de-janeiro",
        stateCode: "RJ",
        id: 3659,
      },
      {
        name: "Belo Horizonte",
        slug: "belo-horizonte",
        state: "Minas Gerais",
        stateSlug: "minas-gerais",
        stateCode: "MG",
        id: 1415,
      },
      {
        name: "Vitória",
        slug: "vitoria",
        state: "Espírito Santo",
        stateSlug: "espirito-santo",
        stateCode: "ES",
        id: 886,
      },
    ],
  },
  {
    name: "Região Centro-Oeste",
    cities: [
      {
        name: "Brasília",
        slug: "brasilia",
        state: "Distrito Federal",
        stateSlug: "distrito-federal",
        stateCode: "DF",
        id: 808,
      },
      {
        name: "Goiânia",
        slug: "goiania",
        state: "Goiás",
        stateSlug: "goias",
        stateCode: "GO",
        id: 981,
      },
      {
        name: "Campo Grande",
        slug: "campo-grande",
        state: "Mato Grosso do Sul",
        stateSlug: "mato-grosso-do-sul",
        stateCode: "MS",
        id: 2222,
      },
      {
        name: "Cuiabá",
        slug: "cuiaba",
        state: "Mato Grosso",
        stateSlug: "mato-grosso",
        stateCode: "MT",
        id: 2319,
      },
    ],
  },
  {
    name: "Região Nordeste",
    cities: [
      {
        name: "Salvador",
        slug: "salvador",
        state: "Bahia",
        stateSlug: "bahia",
        stateCode: "BA",
        id: 2,
      },
      {
        name: "Recife",
        slug: "recife",
        state: "Pernambuco",
        stateSlug: "pernambuco",
        stateCode: "PE",
        id: 16,
      },
      {
        name: "Fortaleza",
        slug: "fortaleza",
        state: "Ceará",
        stateSlug: "ceara",
        stateCode: "CE",
        id: 682,
      },
      {
        name: "São Luís",
        slug: "sao-luis",
        state: "Maranhão",
        stateSlug: "maranhao",
        stateCode: "MA",
        id: 1318,
      },
      {
        name: "Maceió",
        slug: "maceio",
        state: "Alagoas",
        stateSlug: "alagoas",
        stateCode: "AL",
        id: 14,
      },
      {
        name: "Aracaju",
        slug: "aracaju",
        state: "Sergipe",
        stateSlug: "sergipe",
        stateCode: "SE",
        id: 13,
      },
      {
        name: "João Pessoa",
        slug: "joao-pessoa",
        state: "Paraíba",
        stateSlug: "paraiba",
        stateCode: "PB",
        id: 2657,
      },
      {
        name: "Natal",
        slug: "natal",
        state: "Rio Grande do Norte",
        stateSlug: "rio-grande-do-norte",
        stateCode: "RN",
        id: 3771,
      },
      {
        name: "Teresina",
        slug: "teresina",
        state: "Piauí",
        stateSlug: "piaui",
        stateCode: "PI",
        id: 3185,
      },
    ],
  },
  {
    name: "Região Norte",
    cities: [
      {
        name: "Manaus",
        slug: "manaus",
        state: "Amazonas",
        stateSlug: "amazonas",
        stateCode: "AM",
        id: 175,
      },
      {
        name: "Belém",
        slug: "belem",
        state: "Pará",
        stateSlug: "para",
        stateCode: "PA",
        id: 2441,
      },
      {
        name: "Palmas",
        slug: "palmas",
        state: "Tocantins",
        stateSlug: "tocantins",
        stateCode: "TO",
        id: 5509,
      },
      {
        name: "Rio Branco",
        slug: "rio-branco",
        state: "Acre",
        stateSlug: "acre",
        stateCode: "AC",
        id: 32,
      },
      {
        name: "Macapá",
        slug: "macapa",
        state: "Amapá",
        stateSlug: "amapa",
        stateCode: "AP",
        id: 206,
      },
      {
        name: "Porto Velho",
        slug: "porto-velho",
        state: "Rondônia",
        stateSlug: "rondonia",
        stateCode: "RO",
        id: 3887,
      },
      {
        name: "Boa Vista",
        slug: "boa-vista",
        state: "Roraima",
        stateSlug: "roraima",
        stateCode: "RR",
        id: 3905,
      },
    ],
  },
  {
    name: "Região Sul",
    cities: [
      {
        name: "Curitiba",
        slug: "curitiba",
        state: "Paraná",
        stateSlug: "parana",
        stateCode: "PR",
        id: 3288,
      },
      {
        name: "Porto Alegre",
        slug: "porto-alegre",
        state: "Rio Grande do Sul",
        stateSlug: "rio-grande-do-sul",
        stateCode: "RS",
        id: 4242,
      },
      {
        name: "Florianópolis",
        slug: "florianopolis",
        state: "Santa Catarina",
        stateSlug: "santa-catarina",
        stateCode: "SC",
        id: 4501,
      },
    ],
  },
];

export const capitais = {
  "rio-branco": {
    city: "Rio Branco",
    state: "Acre",
    slug: "rio-branco",
  },
  maceio: {
    city: "Maceió",
    state: "Alagoas",
    slug: "maceio",
  },
  macapa: {
    city: "Macapá",
    state: "Amapá",
    slug: "macapa",
  },
  manaus: {
    city: "Manaus",
    state: "Amazonas",
    slug: "manaus",
  },
  salvador: {
    city: "Salvador",
    state: "Bahia",
    slug: "salvador",
  },
  fortaleza: {
    city: "Fortaleza",
    state: "Ceará",
    slug: "fortaleza",
  },
  brasilia: {
    city: "Brasília",
    state: "Distrito Federal",
    slug: "brasilia",
  },
  vitoria: {
    city: "Vitória",
    state: "Espírito Santo",
    slug: "vitoria",
  },
  goiania: {
    city: "Goiânia",
    state: "Goiás",
    slug: "goiania",
  },
  "sao-luis": {
    city: "São Luís",
    state: "Maranhão",
    slug: "sao-luis",
  },
  cuiaba: {
    city: "Cuiabá",
    state: "Mato Grosso",
    slug: "cuiaba",
  },
  "campo-grande": {
    city: "Campo Grande",
    state: "Mato Grosso do Sul",
    slug: "campo-grande",
  },
  "belo-horizonte": {
    city: "Belo Horizonte",
    state: "Minas Gerais",
    slug: "belo-horizonte",
  },
  belem: {
    city: "Belém",
    state: "Pará",
    slug: "belem",
  },
  "joao-pessoa": {
    city: "João Pessoa",
    state: "Paraíba",
    slug: "joao-pessoa",
  },
  curitiba: {
    city: "Curitiba",
    state: "Paraná",
    slug: "curitiba",
  },
  recife: {
    city: "Recife",
    state: "Pernambuco",
    slug: "recife",
  },
  teresina: {
    city: "Teresina",
    state: "Piauí",
    slug: "teresina",
  },
  "rio-de-janeiro": {
    city: "Rio de Janeiro",
    state: "Rio de Janeiro",
    slug: "rio-de-janeiro",
  },
  natal: {
    city: "Natal",
    state: "Rio Grande do Norte",
    slug: "natal",
  },
  "porto-alegre": {
    city: "Porto Alegre",
    state: "Rio Grande do Sul",
    slug: "porto-alegre",
  },
  "porto-velho": {
    city: "Porto Velho",
    state: "Rondônia",
    slug: "porto-velho",
  },
  "boa-vista": {
    city: "Boa Vista",
    state: "Roraima",
    slug: "boa-vista",
  },
  florianopolis: {
    city: "Florianópolis",
    state: "Santa Catarina",
    slug: "florianopolis",
  },
  "sao-paulo": {
    city: "São Paulo",
    state: "São Paulo",
    slug: "sao-paulo",
  },
  aracaju: {
    city: "Aracaju",
    state: "Sergipe",
    slug: "aracaju",
  },
  palmas: {
    city: "Palmas",
    state: "Tocantins",
    slug: "palmas",
  },
};
